import {
    FaBarcode, FaCog, FaClipboardCheck, FaClock,
    FaFileSignature, FaShoppingCart, FaInfoCircle, FaReply,
    FaSearch, FaFileInvoiceDollar, FaCartArrowDown, FaTachometerAlt,
    FaMoneyBill, FaMoneyBillWave,
    FaTruckLoading,
    FaTruck, FaHandPaper, FaBoxOpen, FaDatabase,
    FaLayerGroup,
    FaListAlt,
    FaIndustry, FaCogs, FaRoute, FaClipboardList,
    FaWrench, FaCheckCircle, FaChartBar, FaChartLine,
    FaHeadset,
    FaUsers,
    FaMicrochip,
    FaUndo,
    FaLink,
    FaCalendarAlt,
    FaUpload,
    FaCoins,
    FaFlask,
    FaTools,
    FaSitemap,
    FaLandmark,
    FaBook,
    FaPercent,
    FaWarehouse,
    FaTable,
    FaFileExcel,
    FaExchangeAlt,
    FaBalanceScale,

} from 'react-icons/fa';

export const TILE_REGISTRY = {
    // ==========================================
    // 1. PRODUCT MANAGEMENT TILES
    // ==========================================
    "PROD_CODE": { id: "PROD_CODE", name: "Product Master", icon: FaBarcode, path: "/cable/product/product-code", moduleName: "Product Management" },
    "PROD_CONFIG": { id: "PROD_CONFIG", name: "Product Configuration", icon: FaCog, path: "/cable/product/product-configuration/1", moduleName: "Product Management" },
    "INSP_CHAR": { id: "INSP_CHAR", name: "Inspection Parameters", icon: FaClipboardCheck, path: "/cable/product/inspection-characteristics", moduleName: "Quality Master Data" },

    "INSP_CHAR_DATA_UPDATE": {
    id: "INSP_CHAR_DATA_UPDATE",
    name: "Inspection Parameters Data Update",
    icon: FaFileExcel,
    path: "/cable/product/inspection-characteristics-data-update",
    moduleName: "Quality Master Data"
},

    "QUALITY_MANAGEMENT": {
        id: "QUALITY_MANAGEMENT",
        name: "Quality Configuration",
        icon: FaCogs,
        path: "/cable/product/quality-management",
        moduleName: "Quality Master Data"
    },
    "GTP_CONFIGURATION": {
        id: "GTP_CONFIGURATION",
        name: "GTP Configuration",
        icon: FaMicrochip,
        path: "/cable/product/gtp-configuration",
        moduleName: "Quality Master Data"
    },

    "GTP_DATA_UPDATE": {
    id: "GTP_DATA_UPDATE",
    name: "GTP Data Update",
    icon: FaTable,
    path: "/cable/product/gtp-data-update",
    moduleName: "Quality Master Data"
},

    "PURCHASE_REQ": {
        id: "PURCHASE_REQ",
        name: "Purchase Request",
        icon: FaFileSignature,
        path: "/cable/procurement/purchase-request",
        moduleName: "Purchasing"
    },

    "PURCHASE_ORDER": {
        id: "PURCHASE_ORDER",
        name: "Purchase Order",
        icon: FaShoppingCart,
        path: "/cable/procurement/purchase-order",
        moduleName: "Purchasing"
    },

    "PURCHASE_INFO": {
        id: "PURCHASE_INFO",
        name: "Purchase Info",
        icon: FaInfoCircle,
        path: "/cable/procurement/purchase-info",
        moduleName: "Purchasing"
    },

    "VENDOR_RETURN": {
        id: "VENDOR_RETURN",
        name: "Vendor Return",
        icon: FaReply,
        path: "/cable/procurement/vendor-return",
        moduleName: "Purchasing"
    },

    "PURCHASE_CUSTOM": {
        id: "PURCHASE_CUSTOM",
        name: "Custom",
        icon: FaCog,
        path: "/cable/procurement/custom",
        moduleName: "Purchasing"
    },

    "HELP_DESK": {
        id: "HELP_DESK",
        name: "Help Desk",
        icon: FaHeadset,
        path: "/cable/help-desk",
        moduleName: "Master Data"
    },
    // ==========================================
    // 3. SALES TILES (Yahan se Dashboards ko alag module name de diya gaya hai)
    // ==========================================
    "SALES_INQUIRY": { id: "SALES_INQUIRY", name: "Enquiry", icon: FaSearch, path: "/cable/sales/enquiry", moduleName: "Sales" },
    "SALES_QUOTATION": { id: "SALES_QUOTATION", name: "Quotation", icon: FaFileInvoiceDollar, path: "/cable/sales/quotation", moduleName: "Sales" },
    "SALES_ORDER": { id: "SALES_ORDER", name: "Sales Order", icon: FaCartArrowDown, path: "/cable/sales/sales-order", moduleName: "Sales" },
    // "SALES_DASHBOARD": { id: "SALES_DASHBOARD", name: "Dashboard", icon: FaTachometerAlt, path: "/cable/sales/dashboard", moduleName: "Sales Dashboard" }, 
    "SALES_CUSTOMER_SUPPORT": { id: "SALES_CUSTOMER_SUPPORT", name: "Customer Support", icon: FaHeadset, path: "/cable/sales/customer-support", moduleName: "Sales" },
    "SALES_CRM": { id: "SALES_CRM", name: "Customer Relationship Management", icon: FaUsers, path: "/cable/sales/crm", moduleName: "Sales" },
    // "SALES_ATO": { id: "SALES_ATO", name: "RFQ for ATO", icon: FaCog, path: "/cable/sales/rfq-ato", moduleName: "Sales" },
    // "BOM": { id: "BOM", name: "BOM", icon: FaFileSignature, path: "/cable/bomrfq", moduleName: "Sales" },

    "SALES_CHECKLIST": {
        id: "SALES_CHECKLIST",
        name: "Checklist  Configuration",
        icon: FaClipboardCheck,
        path: "/cable/sales/checklist",
        moduleName: "Sales"
    },

    "INQUIRY_DASHBOARD": {
        id: "INQUIRY_DASHBOARD",
        name: "Enquiry Dashboard",
        icon: FaChartBar,
        path: "/cable/sales/inquiry-dashboard",
        moduleName: "Sales Dashboard"
    },
    "RFQ_DASHBOARD": {
        id: "RFQ_DASHBOARD",
        name: "RFQ Dashboard",
        icon: FaChartBar,
        path: "/cable/sales/rfq-dashboard",
        moduleName: "Sales Dashboard"
    },

    "SALES_ORDER_DASHBOARD": { id: "SALES_ORDER_DASHBOARD", name: "Sales Order Dashboard", icon: FaChartLine, path: "/cable/sales/sales-order-dashboard", moduleName: "Sales Dashboard" },

    // "COMPLAINT_RETURN_DASHBOARD": { id: "COMPLAINT_RETURN_DASHBOARD", name: "Complain/Return Dashboard", icon: FaChartLine, path: "/cable/sales/complain-return-dashboard", moduleName: "Sales Dashboard" },


    // ==========================================
    // 4. BILLING TILES
    // ==========================================
    "BILLING_CREATE": { id: "BILLING_CREATE", name: "Create Billing", icon: FaMoneyBill, path: "/cable/billing/billing", moduleName: "Billing" },
    "BILLING_REVIEW": { id: "BILLING_REVIEW", name: "Billing Review", icon: FaMoneyBillWave, path: "/cable/billing/review", moduleName: "Billing" },


    // ==========================================
    // 5. INBOUND PROCESS TILES
    // ==========================================
    "INBOUND_GOODS_RECEIPT": { id: "INBOUND_GOODS_RECEIPT", name: "Goods Receipt", icon: FaTruckLoading, path: "/cable/goods-receipt/goods-receipt", moduleName: "Inbound Process" },

    "INBOUND_RETURN_RECEIPT": { id: "INBOUND_RETURN_RECEIPT", name: "Return Receipt", icon: FaUndo, path: "/cable/inbound/return-receipt", moduleName: "Inbound Process" },
    "INBOUND_GATE_PASS": {
        id: "INBOUND_GATE_PASS",
        name: "Gate Pass",
        icon: FaTruck,   // or FaFileSignature
        path: "/cable/inbound/gate-pass",
        moduleName: "Inbound Process"
    },

    "INBOUND_PUT_AWAY": {
        id: "INBOUND_PUT_AWAY",
        name: "Put Away",
        icon: FaWarehouse,
        path: "/cable/inbound/put-away",
        moduleName: "Inbound Process"
    },

    "INBOUND_GR_DASHBOARD": {
        id: "INBOUND_GR_DASHBOARD",
        name: "GRN Dashboard",
        icon: FaTachometerAlt,
        path: "/cable/inbound/grn-dashboard",
        moduleName: "Logistics Dashboard"
    },

    // ==========================================
    // 6. GOODS RECEIPT TILES
    // ==========================================
    // NOTE: "Goods Receipt" as its own moduleName group is no longer used —
    // its two tiles (GR_RECEIPT, GR_DASHBOARD) were the intermediate page.
    // They're now folded into "Inbound Process" above (INBOUND_GOODS_RECEIPT,
    // INBOUND_GR_DASHBOARD), so both entries below are commented out.
    // Delete this block once you've confirmed nothing else references them.
    // "GR_RECEIPT": { id: "GR_RECEIPT", name: "Goods Receipt", icon: FaBox, path: "/cable/goods-receipt/goods-receipt", moduleName: "Goods Receipt" },
    // "GR_DASHBOARD": {
    //     id: "GR_DASHBOARD",
    //     name: "Dashboard",
    //     icon: FaTachometerAlt,
    //     path: "/cable/inbound/grn-dashboard",
    //     moduleName: "Goods Receipt"
    // },
    "CONSUMPTION_DASHBOARD": {
        id: "CONSUMPTION_DASHBOARD",
        name: "Consumption Dashboard",
        icon: FaChartBar,
        path: "/cable/stock/consumption-dashboard",
        moduleName: "Stock Dashboard"
    },
    // ==========================================
    // 7. OUTBOUND TILES
    // ==========================================
    "OUTBOUND_DELIVERY": { id: "OUTBOUND_DELIVERY", name: "Outbound Delivery", icon: FaTruck, path: "/cable/outbound-process/outbound-delivery", moduleName: "Outbound" },
    "OUTBOUND_PICKING": { id: "OUTBOUND_PICKING", name: "Picking", icon: FaHandPaper, path: "/cable/outbound-process/picking", moduleName: "Outbound" },
    "OUTBOUND_PACKING": { id: "OUTBOUND_PACKING", name: "Packing", icon: FaBoxOpen, path: "/cable/outbound-process/packing", moduleName: "Outbound" },
    "OUTBOUND_GOODS_ISSUE": {
        id: "OUTBOUND_GOODS_ISSUE",
        name: "Goods Issue",
        icon: FaTruckLoading,
        path: "/cable/outbound-process/goods-issue",
        moduleName: "Outbound"
    },

    // "OUTBOUND_DASHBOARD": {
    //     id: "OUTBOUND_DASHBOARD",
    //     name: "Packing Dashboard",
    //     icon: FaDatabase,
    //     path: "/cable/outbound-process/dashboard",
    //     moduleName: "Logistics Dashboard"
    // },



    // ==========================================
    // 8. WAREHOUSE MASTER TILES (NAYI CATEGORY)
    // ==========================================
    "WAREHOUSE_STORAGE_TYPE": { id: "WAREHOUSE_STORAGE_TYPE", name: "Storage Type", icon: FaLayerGroup, path: "/cable/warehouse/storage-type", moduleName: "Warehouse Master" },
    "WAREHOUSE_STORAGE_BIN": { id: "WAREHOUSE_STORAGE_BIN", name: "Storage Bin", icon: FaBoxOpen, path: "/cable/warehouse/storage-bin", moduleName: "Warehouse Master" },

    // ==========================================
    // 9. PRODUCT PLANNING TILES (NAYI CATEGORY)
    // ==========================================
    "PLANNING_BLOCK": {
        id: "PLANNING_BLOCK",
        name: "Planning Block",
        icon: FaClock,
        path: "/cable/planning-block",
        moduleName: "Product Planning"
    },
    "PLANNING_PRODUCT": { id: "PLANNING_PRODUCT", name: "Product Planning", icon: FaListAlt, path: "/cable/productplanning", moduleName: "Product Planning" },
    "PLANNING_PEGGING": { id: "PLANNING_PEGGING", name: "Planning Report", icon: FaLink, path: "/cable/productplanning/pegging", moduleName: "Product Planning" },
    "PLANNING_LOG": { id: "PLANNING_LOG", name: "Planning Log", icon: FaBook, path: "/cable/productplanning/planning-log", moduleName: "Product Planning" },
    "SALES_PLANNING": { id: "SALES_PLANNING", name: "Order Tree", icon: FaChartLine, path: "/cable/productplanning/order-tree", moduleName: "Product Planning" },
    "LEAD_TIME": { id: "LEAD_TIME", name: "Lead Time Management", icon: FaClock, path: "/cable/product/lead", moduleName: "Product Planning" },


    // ==========================================
    // 10. MASTER DATA TILES (NAYI CATEGORY)
    // ==========================================
    "MD_WORKCENTER": { id: "MD_WORKCENTER", name: "Workcenter", icon: FaIndustry, path: "/cable/master-data/workcenter", moduleName: "Master Data" },
    "MD_BOM": { id: "MD_BOM", name: "Bill of Materials", icon: FaClipboardList, path: "/cable/master-data/bom", moduleName: "Master Data" },
    "MD_ROUTING_CONFIG": { id: "MD_ROUTING_CONFIG", name: "Routing Configuration", icon: FaCogs, path: "/cable/master-data/routing-configuration", moduleName: "Master Data" },
    "MD_ROUTING": { id: "MD_ROUTING", name: "Routing", icon: FaRoute, path: "/cable/master-data/routings", moduleName: "Master Data" },
    "MD_ROUTING_UPLOAD": {
        id: "MD_ROUTING_UPLOAD",
        name: "Routing Data Upload",
        icon: FaUpload,
        path: "/cable/master-data/routing-upload",
        moduleName: "Master Data"
    },

    "PRODUCT_MASTER_DATA": { id: "PRODUCT_MASTER_DATA", name: "Product Master Data", icon: FaDatabase, path: "/cable/config/master-data/product-master", moduleName: "Master Data" },

    // ==========================================
    // 11. SHOP FLOOR CONTROL TILES (NAYI CATEGORY)
    // ==========================================
    "SFC_PLANNED_ORDER": {
        id: "SFC_PLANNED_ORDER", name: "Planned Order", icon: FaClipboardList,
        path: "/planned-order", moduleName: "Shop Floor Control"
    },
    "SFC_PRODUCTION_ORDER": {
        id: "SFC_PRODUCTION_ORDER", name: "Production Order", icon: FaIndustry,
        path: "/cable/production-order", moduleName: "Shop Floor Control"
    },
    "SFC_REWORK_ORDER": {
        id: "SFC_REWORK_ORDER", name: "Rework Order", icon: FaWrench,
        path: "/rework-order", moduleName: "Shop Floor Control"
    },
    "SFC_CONFIRMATION": {
        id: "SFC_CONFIRMATION", name: "Confirmation", icon: FaCheckCircle,
        path: "/cable/confirmation", moduleName: "Shop Floor Control"
    },

    "SFC_GOODS_REQUEST": {
        id: "SFC_GOODS_REQUEST",
        name: "Goods Request",
        icon: FaBoxOpen,
        path: "/cable/goods-request",
        moduleName: "Shop Floor Control"
    },
    "SFC_GOODS_RETURN": {
        id: "SFC_GOODS_RETURN",
        name: "Goods Return",
        icon: FaReply,
        path: "/cable/goods-return",
        moduleName: "Shop Floor Control"
    },

    "SFC_BATCH_LIST": {
        id: "SFC_BATCH_LIST",
        name: "Stock Report",
        icon: FaListAlt,
        path: "/cable/batch-list",
        moduleName: "Inventory"
    },

    // ==========================================
    // 12. QUALITY MANAGEMENT TILES (NAYI CATEGORY)
    // ==========================================
    // Quality Inspection is split into 3 tiles / 3 screens (one backend, one table).
    // QM_INSPECTION keeps its original id (role permissions + pinned favourites
    // already reference it) and now maps to the RM screen.
    "QM_INSPECTION_FG": {
        id: "QM_INSPECTION_FG", name: "Quality Inspection - FG", icon: FaClipboardCheck,
        path: "/quality/inspection-fg", moduleName: "Quality Management"
    },
    "QM_INSPECTION": {
        id: "QM_INSPECTION", name: "Quality Inspection - RM", icon: FaBoxOpen,
        path: "/quality/inspection-rm", moduleName: "Quality Management"
    },
    "QM_STORE_CHECK": {
        id: "QM_STORE_CHECK", name: "Store Check", icon: FaWarehouse,
        path: "/quality/store-check", moduleName: "Quality Management"
    },
    // "QM_CUSTOMER_INSP": {
    //     id: "QM_CUSTOMER_INSP", name: "Customer Inspection", icon: FaUserCheck,
    //     path: "/quality/customer-inspection", moduleName: "Quality Management"
    // },
    // "QM_DASHBOARD": {
    //     id: "QM_DASHBOARD", name: "Dashboard", icon: FaChartBar,
    //     path: "/quality/dashboard", moduleName: "Quality Management"
    // },
    "AUDIT_CALENDAR": {
        id: "AUDIT_CALENDAR",
        name: "Inspection Calendar",
        icon: FaCalendarAlt,
        path: "/cable/quality/audit-calendar",
        moduleName: "Quality Management"
    },

    "MATERIAL_CONFIG": {
        id: "MATERIAL_CONFIG",
        name: "Material Config",
        icon: FaCogs,
        path: "/cable/material-config",
        moduleName: "Configuration"
    },
    "SFC_PRODUCTION_ORDER_DASHBOARD": {
        id: "SFC_PRODUCTION_ORDER_DASHBOARD",
        name: "Production Order Dashboard",
        icon: FaChartBar,
        path: "/cable/production/production-order-dashboard",
        moduleName: "Production Dashboard"
    },
    "SFC_CONFIRMATION_DASHBOARD": {
        id: "SFC_CONFIRMATION_DASHBOARD",
        name: "Confirmation Dashboard",
        icon: FaChartBar,
        path: "/cable/production/confirmation-dashboard",
        moduleName: "Production Dashboard"
    },


    "INVOICE_VERIFICATION": {
        id: "INVOICE_VERIFICATION",
        name: "Invoice Verification",
        icon: FaFileInvoiceDollar,
        path: "/finance/invoice-verification",
        moduleName: "Finance"
    },

    "SUPPLIER_PAYMENT": {
        id: "SUPPLIER_PAYMENT",
        name: "Supplier Payment",
        icon: FaMoneyBillWave,
        path: "/finance/supplier-payment",
        moduleName: "Finance"
    },

    "PAYABLES_DASHBOARD": {
        id: "PAYABLES_DASHBOARD",
        name: "Accounts Payables Dashboard",
        icon: FaMoneyBillWave,
        path: "/finance/dashboard/payables-dashboard",
        moduleName: "Finance Dashboard"
    },

    // ==========================================
    // FINANCE DASHBOARD TILES
    // ==========================================
    "CFO_DASHBOARD": {
        id: "CFO_DASHBOARD",
        name: "CFO Dashboard",
        icon: FaTachometerAlt,
        path: "/finance/dashboard/cfo-dashboard",
        moduleName: "Management Dashboard"
    },

    "COO_DASHBOARD": {
        id: "COO_DASHBOARD",
        name: "COO Dashboard",
        icon: FaTachometerAlt,
        path: "/finance/dashboard/coo-dashboard",
        moduleName: "Management Dashboard"
    },

    "CSO_DASHBOARD": {
        id: "CSO_DASHBOARD",
        name: "CSO Dashboard",
        icon: FaTachometerAlt,
        path: "/finance/dashboard/cso-dashboard",
        moduleName: "Management Dashboard"
    },

    // ==========================================
    // BANK RECONCILIATION TILES
    // ==========================================
    "BANK_Communication": {
        id: "BANK_Communication",
        name: "Bank Statement",
        icon: FaLandmark,
        path: "/finance/bank-communication/bank-statement",
        moduleName: "Bank Commnunication"
    },

    // ==========================================
    // ACCOUNT RECEIVABLE TILES
    // ==========================================
    "PAYMENT_RUN": {
        id: "PAYMENT_RUN",
        name: "Payment Run",
        icon: FaMoneyBillWave,
        path: "/finance/account-receivable/payment-run",
        moduleName: "Account Receivable"
    },

        "AR_DASHBOARD": {
        id: "AR_DASHBOARD",
        name: "Accounts Receivables Dashboard",
        icon: FaUsers,
        path: "/finance/dashboard/receivables-dashboard",
        moduleName: "Finance Dashboard"
    },

    "BUDGET_PLANNING": {
        id: "BUDGET_PLANNING",
        name: "Budget Planning",
        icon: FaCoins,
        path: "/finance/budget-planning/entry",
        moduleName: "Budget Planning"
    },


    // ==========================================
    // 13. CONTROLLING - PRODUCT COSTING TILES (NAYI CATEGORY)
    // ==========================================
    "PRODUCT_COSTING": {
        id: "PRODUCT_COSTING",
        name: "Product Costing",
        icon: FaFileInvoiceDollar,
        path: "/controlling/product-costing/product-costing",
        moduleName: "Product Costing"
    },
    "ACTIVITY_RATE": {
        id: "ACTIVITY_RATE",
        name: "Activity Rate",
        icon: FaCoins,
        path: "/controlling/product-costing/activity-rate",
        moduleName: "Product Costing"
    },

    "LAB_CALIBRATION_STANDARD": {
        id: "LAB_CALIBRATION_STANDARD",
        name: "Lab Calibration Standard",
        icon: FaFlask,
        path: "/quality/lab-calibration-standard",
        moduleName: "Quality Master Data"
    },

    "LAB_EQUIPMENT": {
        id: "LAB_EQUIPMENT",
        name: "Lab Equipment",
        icon: FaTools,
        path: "/quality/lab-equipment",
        moduleName: "Quality Master Data"
    },

    // ==========================================
    // 14. INVENTORY MANAGEMENT TILES (NAYI CATEGORY)
    // ==========================================
    "SFC_BATCH_TREE": {
        id: "SFC_BATCH_TREE",
        name: "Batch Tree",
        icon: FaSitemap,
        path: "/cable/production/batch-tree",
        moduleName: "Inventory"
    },

    "INVENTORY_PHYSICAL": {
        id: "INVENTORY_PHYSICAL",
        name: "Physical Inventory",
        icon: FaClipboardList,
        path: "/cable/inventory/physical-inventory",
        moduleName: "Inventory"
    },

    "INVENTORY_DASHBOARD": {
        id: "INVENTORY_DASHBOARD",
        name: "Inventory",
        icon: FaClipboardList,
        path: "/cable/inventory/inventory",
        moduleName: "Logistics Dashboard"
    },

    // ==========================================
    // GENERAL LEDGER TILES
    // ==========================================
    "GL_ACCOUNT_POSTING": {
        id: "GL_ACCOUNT_POSTING",
        name: "Account Posting",
        icon: FaBook,
        path: "/finance/gl/account-posting",
        moduleName: "General Ledger"
    },

    "GL_VARIANCE": {
        id: "GL_VARIANCE",
        name: "Variance Posting",
        icon: FaBalanceScale,
        path: "/finance/gl/variance",
        moduleName: "General Ledger"
    },

    // ==========================================
    // LOCALIZATION TILES
    // ==========================================
    "GST": {
        id: "GST",
        name: "GST",
        icon: FaPercent,
        path: "/cable/localization/gst",
        moduleName: "Localization"
    },

    "EXCHANGE_RATE": {
        id: "EXCHANGE_RATE",
        name: "Exchange Rate",
        icon: FaExchangeAlt,
        path: "/cable/localization/exchange-rate",
        moduleName: "Localization"
    },

    "TERMS_CONFIG": {
        id: "TERMS_CONFIG",
        name: "Terms & Conditions",
        icon: FaFileSignature,
        path: "/cable/config/master-data/terms-conditions",
        moduleName: "Master Data"
    },
    "LOCATION": {
        id: "LOCATION",
        name: "Location Master",
        icon: FaSitemap,
        path: "/cable/location",
        moduleName: "Configuration"
    },

    "USER_MANAGEMENT": {
        id: "USER_MANAGEMENT",
        name: "User Management",
        icon: FaUsers,
        path: "/cable/user",
        moduleName: "Configuration"
    },

    "USER_MANUAL_UPDATE": {
        id: "USER_MANUAL_UPDATE",
        name: "Update User Manual",
        icon: FaBook,
        path: "/cable/config/user-manual/manage",
        moduleName: "User Manual"
    },
    "SALES_SCHEDULING": {
    id: "SALES_SCHEDULING",
    name: "Scheduling",
    icon: FaCalendarAlt,
    path: "/cable/productplanning/scheduling",
    moduleName: "Product Planning"
},
BUSINESS_PARTNER: {
  id: "BUSINESS_PARTNER",
  name: "Business Partner",
  moduleName: "Master Data",   // or a new group, e.g. "Business Partner"
  // ...same other keys (path, icon, etc.) as your other tiles
},
};